import Vue from 'vue'
import Router from 'vue-router'

import AuthView from '@/auth/AuthView'

import store from '@/store'
import AmplifyStore from '@/store/modules/AmplifyStore'

import {
  Auth,
  Logger
} from 'aws-amplify'

const logger = new Logger('AuthRouter')

Vue.use(Router)

const AuthFilter = (to, from, next) => {
  logger.debug('before routing ', to, from)
  Auth.currentAuthenticatedUser()
    .then(user => {
      logger.debug('...has user', user)
      AmplifyStore.commit('setUser', user)
      Auth.currentCredentials()
        .then(credentials => {
          AmplifyStore.commit('setUserId', credentials.identityId)
          next()
        })
        .catch(err => logger.debug('get current credentials err', err))
    })
    .catch(err => {
      logger.debug('...no user', err)
      AmplifyStore.commit('setUser', null)
      if (!to.name.startsWith('auth')) {
        next({
          path: '/auth/signIn',
          query: {
            redirect: to.fullPath
          }
        })
      } else {
        next()
      }
    })
}

const UserGroupSetter = (to, from, next) => {
  logger.debug('UserGroupSetter:', store.getters.currentUserGroup)
  if (!store.getters.currentUserGroup) {
    logger.debug('UserGroupSetter::::::...no currentUserGroup')
    next({
      path: '/'
    })
  } else {
    next()
  }
}

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/pages/Dashboard'),
      beforeEnter: AuthFilter
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('@/pages/Dashboard'),
      beforeEnter: AuthFilter
    },
    {
      path: '/signout',
      beforeEnter (to, from, next) {
        Auth.signOut()
          .then(() => {
            logger.debug('sign out success')
            next('/auth/signin')
          })
          .catch(err => {
            this.setError(err)
            next('/auth/signin')
          })
      }
    },
    {
      path: '/auth',
      name: 'auth',
      component: AuthView,
      children: [{
        path: 'signIn',
        name: 'auth_SignIn',
        component: () => import('@/auth/components/SignIn')
      }]
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/pages/UserSettings'),
      beforeEnter: AuthFilter
    },
    {
      path: '/usergroups',
      name: 'userGroups',
      component: () => import('@/pages/UserGroups'),
      beforeEnter: AuthFilter
    },
    {
      path: '/users/felicas',
      name: 'userFelicas',
      component: () => import('@/pages/UserFelicas'),
      beforeEnter: AuthFilter
    },
    {
      path: '/users/daily_enquetes',
      name: 'userDailyEnquetes',
      component: () => import('@/pages/UserDailyEnquetes'),
      beforeEnter: AuthFilter
    },
    {
      path: '/cognito_users',
      name: 'cognitoUsers',
      component: () => import('@/pages/CognitoUsers'),
      beforeEnter: AuthFilter
    },
    {
      path: '/usergroups/:groupId',
      name: 'userGroupView',
      component: () => import('@/pages/userGroups/UserGroupView'),
      beforeEnter: AuthFilter,
      children: [
        {
          path: 'top',
          name: 'userGroupTop',
          component: () => import('@/pages/userGroups/Top'),
          beforeEnter: UserGroupSetter
        },
        {
          path: 'members',
          name: 'userGroupMembers',
          component: () => import('@/pages/userGroups/Members')
        },
        {
          path: 'user/new',
          name: 'userRegister',
          component: () => import('@/pages/userGroups/UserRegister')
        },
        {
          path: 'felicas/new',
          name: 'felicaRegister',
          component: () => import('@/pages/userGroups/FelicaRegister')
        },
        {
          path: 'userfelica',
          name: 'userFelicaSettings',
          component: () => import('@/pages/userGroups/UserFelicaSettings')
        },
        {
          path: 'append',
          name: 'appendUser',
          component: () => import('@/pages/userGroups/AppendUser')
        },
        {
          path: 'users/:userId',
          name: 'userDisplay',
          component: () => import('@/pages/userGroups/UserDisplay')
        }
      ]
    }
  ]
})
